import { useState } from "react"
import { useDispatch } from "react-redux"
import { updateFee, fetchFees } from "../store/slices/feeSlice"
import { Calculator, X } from "lucide-react"

const EditFee = ({ fee, setShowEditModal }) => {
  const dispatch = useDispatch()
  const [formLoading, setFormLoading] = useState(false)
  const [formData, setFormData] = useState({
    student_id: fee.student_id,
    amount: fee.amount.toString(),
    status: fee.status,
    transaction_id: fee.transaction_id || "",
    meta: fee.meta || "",
    utr_number: fee.utr_number || "",
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setFormLoading(true)
    const submitData = {
      student_id: formData.student_id,
      amount: formData.amount,
      status: formData.status,
      transaction_id: formData.transaction_id,
      meta: formData.meta,
      utr_number: formData.utr_number,
    }
    dispatch(updateFee({ id: fee.fee_id, data: submitData }))
      .unwrap()
      .then(() => {
        dispatch(fetchFees())
        setShowEditModal(false)
      })
      .catch((err) => {
        dispatch({
          type: "fees/setMessage",
          payload: { text: `Error updating fee: ${err.message || "Unknown error"}`, type: "error" },
        })
      })
      .finally(() => setFormLoading(false))
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Calculator className="w-6 h-6 text-blue-600" />
          <h3 className="text-xl font-semibold text-foreground">Edit Fee</h3>
        </div>
        <button
          onClick={() => setShowEditModal(false)}
          className="p-2 text-gray-600 hover:text-gray-800"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1">Student ID:</label>
            <input
              type="number"
              name="student_id"
              value={formData.student_id}
              onChange={handleInputChange}
              required
              disabled={formLoading}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1">Amount:</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleInputChange}
              required
              disabled={formLoading}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1">Status:</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              required
              disabled={formLoading}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Pending">Pending</option>
              <option value="Paid">Paid</option>
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1">Transaction ID:</label>
            <input
              type="text"
              name="transaction_id"
              value={formData.transaction_id}
              onChange={handleInputChange}
              disabled={formLoading}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1">UTR Number:</label>
            <input
              type="text"
              name="utr_number"
              value={formData.utr_number}
              onChange={handleInputChange}
              disabled={formLoading}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-4 col-span-2">
            <label className="block text-gray-700 font-medium mb-1">Meta (Additional Info):</label>
            <textarea
              name="meta"
              value={formData.meta}
              onChange={handleInputChange}
              rows="3"
              disabled={formLoading}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="mt-6 flex space-x-4">
          <button
            type="submit"
            className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
            disabled={formLoading}
          >
            Update Fee
          </button>
          <button
            type="button"
            onClick={() => setShowEditModal(false)}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-lg transition duration-200"
            disabled={formLoading}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}

export default EditFee